import { EMPTY, getCell, indexOf } from './board.js';
function colorOf(cell) {
    return cell.kind === 'virus' || cell.kind === 'segment' ? cell.color : null;
}
/**
 * Находит все клетки, входящие в горизонтальные или вертикальные ряды одного цвета длиной ≥ matchLength.
 * Вирусы и сегменты капсул считаются одинаково. Пересекающиеся ряды объединяются:
 * каждая клетка учитывается один раз. Возвращает отсортированные индексы клеток.
 */
export function findMatches(board, matchLength) {
    const marked = new Set();
    const scan = (length, cellAt) => {
        let runStart = 0;
        for (let i = 1; i <= length; i++) {
            const prev = colorOf(board.cells[cellAt(i - 1)] ?? EMPTY);
            const current = i < length ? colorOf(board.cells[cellAt(i)] ?? EMPTY) : null;
            if (current !== null && current === prev) {
                continue;
            }
            if (prev !== null && i - runStart >= matchLength) {
                for (let j = runStart; j < i; j++) {
                    marked.add(cellAt(j));
                }
            }
            runStart = i;
        }
    };
    for (let y = 0; y < board.height; y++) {
        scan(board.width, (x) => indexOf(board, x, y));
    }
    for (let x = 0; x < board.width; x++) {
        scan(board.height, (y) => indexOf(board, x, y));
    }
    return [...marked].sort((a, b) => a - b);
}
const PARTNER_OFFSET = {
    left: [-1, 0],
    right: [1, 0],
    up: [0, -1],
    down: [0, 1],
};
/** Удаляет клетки; уцелевшая половина капсулы становится одиночным сегментом. */
export function clearCells(board, indices) {
    const cells = board.cells.slice();
    const cleared = [];
    let viruses = 0;
    let segments = 0;
    let shields = 0;
    for (const index of indices) {
        const cell = cells[index];
        if (cell === undefined || (cell.kind !== 'virus' && cell.kind !== 'segment')) {
            continue;
        }
        const x = index % board.width;
        const y = Math.floor(index / board.width);
        if (cell.kind === 'virus' && cell.shield) {
            // Первая очистка снимает «Биоплёнку»: вирус остаётся на месте без защиты (сторожевой — сторожевым).
            cleared.push({ x, y, kind: 'shield', color: cell.color });
            cells[index] = cell.guard
                ? { kind: 'virus', color: cell.color, guard: true }
                : { kind: 'virus', color: cell.color };
            shields++;
            continue;
        }
        cleared.push({ x, y, kind: cell.kind, color: cell.color });
        if (cell.kind === 'virus') {
            viruses++;
        }
        else {
            segments++;
        }
        cells[index] = EMPTY;
    }
    for (const { x, y, kind } of cleared) {
        if (kind !== 'segment') {
            continue;
        }
        const original = getCell(board, x, y);
        if (original.kind !== 'segment' || original.link === 'none') {
            continue;
        }
        const [dx, dy] = PARTNER_OFFSET[original.link];
        const partnerIndex = indexOf(board, x + dx, y + dy);
        const partner = cells[partnerIndex];
        if (partner?.kind === 'segment') {
            cells[partnerIndex] = { kind: 'segment', color: partner.color, link: 'none' };
        }
    }
    return { board: { ...board, cells }, cleared, viruses, segments, shields };
}
//# sourceMappingURL=match-resolver.js.map